// Home.jsx
import React from "react";
import "../Styles/Home.scss";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Service from "../Image/service.jpg";
import Img1 from "../Image/measure.jpg";
import Img2 from "../Image/excavator.jpg";
import Img3 from "../Image/materials.jpg";
import pic1 from "../Image/8.jpeg";
import pic2 from "../Image/9.jpeg";
import pic3 from "../Image/3.jpeg"; 
import pic4 from "../Image/5.jpeg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; // <-- import translation hook

const Home = () => {
  const { t } = useTranslation(); // <-- get t function

  const openToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      {/* Hero Section */}
      <div className="background">
        <h1>{t("emibau")}</h1>
        <h3>{t("hero_description")}</h3>
        <Link to="/contact">
          <button onClick={openToTop}>{t("home_get_a_quote")}</button>
        </Link>
      </div>

      {/* Services Section */}
      <div className="works">
        <div className="card1">
          <div className="icon"></div>
          <h2>{t("home_drywall_installation_title")}</h2>
          <h3>{t("home_drywall_installation_desc")}</h3>
        </div>

        <div className="card2">
          <div className="icon"></div>
          <h2>{t("interior_partition_title")}</h2>
          <h3>{t("interior_partition_desc")}</h3>
        </div>

        <div className="card3">
          <div className="icon"></div>
          <h2>{t("excavator_rentals_title")}</h2>
          <h3>{t("excavator_rentals_desc")}</h3>
        </div>
      </div>

      {/* Specialized Section */}
      <div className="wwd">
        <div className="desc">
          <h1>{t("specialized_for")}</h1>
          <p>{t("specialized_desc")}</p>
        </div>
        <div className="wwd-img">
          <img alt="services" src={Service} className="service" />
        </div>
      </div>

      {/* Offer Section */}
      <div className="offer">
        <h1>{t("what_we_offer")}</h1>
        <div className="panel">
          <div className="panel1">
            <img src={Img1} alt="service" />
            <h2>{t("offer_quality")}</h2>
            <p>{t("offer_quality_desc")}</p>
          </div>
          <div className="panel2">
            <img src={Img2} alt="service" />
            <h2>{t("offer_equipment")}</h2>
            <p>{t("offer_equipment_desc")}</p>
          </div>
          <div className="panel3">
            <img src={Img3} alt="service" />
            <h2>{t("offer_team")}</h2>
            <p>{t("offer_team_desc")}</p>
          </div>
        </div>
      </div>

      {/* Projects Section */}
      <div className="projects">
        <div className="gallery">
          <img src={pic1} alt="construction" />
          <img src={pic2} alt="construction" />
          <img src={pic3} alt="construction" />
          <img src={pic4} alt="construction" />
        </div>
        <div className="projects-desc">
          <h1>{t("discover_our_work")}</h1>
          <p>{t("discover_our_work_desc")}</p>
          <Link to="/projects">
            <button onClick={openToTop}>{t("our_projects")}</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;


// import React from "react";
// import "../Styles/Home.scss";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import Service from "../Image/service.jpg";
// import Img1 from "../Image/measure.jpg";
// import Img2 from "../Image/excavator.jpg";
// import Img3 from "../Image/materials.jpg";
// import pic1 from "../Image/8.jpeg";
// import pic2 from "../Image/9.jpeg";
// import pic3 from "../Image/3.jpeg";
// import pic4 from "../Image/5.jpeg";
// import { Link } from "react-router-dom";

// const Home = () => {
//   const openToTop = () => {
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: "smooth",
//     });
//   };
//   return (
//     <div>
//       <div className="background">
//         <h1>EMIBAU</h1>
//         <h3>
//           Emibau provides reliable drywall construction services, built on
//           experience, precision, and a commitment to quality.
//         </h3>
//         <Link to="/contact">
//           <button onClick={openToTop}>Get a Quote</button>
//         </Link>
//       </div>
//       <div className="works">
//         <div className="card1">
//           <div className="icon"></div>
//           <h2>Drywall Installation</h2>
//           <h3>
//             Professional drywall construction for residential and commercial
//             spaces. We deliver clean finishes, precise alignment, and
//             long-lasting results.
//           </h3>
//         </div>

//         <div className="card2">
//           <div className="icon"></div>
//           <h2>Interior Partitioning</h2>
//           <h3>
//             Custom wall partitions designed to optimize your space based on your
//             preferences and style. Perfect for offices, homes, and commercial
//             renovations.
//           </h3>
//         </div>

//         <div className="card3">
//           <div className="icon"></div>
//           <h2>Excavator Rentals</h2>
//           <h3>
//             Reliable excavator rental services for construction, landscaping,
//             and groundwork projects, operated with safety and efficiency.
//           </h3>
//         </div>
//       </div>
//       <div className="wwd">
//         <div className="desc">
//           <h1>SPECIALIZED FOR</h1>
//           <p>
//             We are specialized in professional drywall construction, delivering
//             precise and durable installations for every project. Our experienced
//             team combines skill, attention to detail, and modern techniques to
//             ensure flawless finishes. We use high-quality materials and follow
//             industry best practices to guarantee long-lasting results. Every
//             project, whether residential or commercial, is handled with care,
//             efficiency, and dedication. At Emibau, precision, quality, and
//             customer satisfaction are at the core of everything we do.
//           </p>
//         </div>
//         <div className="wwd-img">
//           <img alt="services" src={Service} className="service" />
//         </div>
//       </div>
//       <div className="offer">
//         <h1>WHAT WE OFFER</h1>
//         <div className="panel">
//           <div className="panel1">
//             <img src={Img1} alt="service" />
//             <h2>Quality & Precision</h2>
//             <p>
//               Precision craftsmanship meets premium quality in every drywall
//               installation. Our team ensures smooth finishes, accurate
//               alignment, and long-lasting performance.
//             </p>
//           </div>
//           <div className="panel2">
//             <img src={Img2} alt="service" />
//             <h2>Modern Equipment</h2>
//             <p>
//               Our fleet of modern excavators guarantees high performance and
//               maximum efficiency. Built for demanding jobs, our equipment
//               ensures safe and accurate groundwork.
//             </p>
//           </div>
//           <div className="panel3">
//             <img src={Img3} alt="service" />
//             <h2>Experienced Team</h2>
//             <p>
//               Our experienced team brings skill, dedication, and attention to
//               detail to every project. Years of hands-on expertise ensure
//               reliable results and high-quality workmanship.
//             </p>
//           </div>
//         </div>
//       </div>
//       <div className="projects">
//         <div className="gallery">
//           <img src={pic1} alt="construction" />
//           <img src={pic2} alt="construction" />
//           <img src={pic3} alt="construction" />
//           <img src={pic4} alt="construction" />
//         </div>
//         <div className="projects-desc">
//           <h1>DISCOVER OUR WORK</h1>
//           <p>
//             Discover our work and see the quality and precision we bring to
//             every project. From drywall installations to custom interior
//             solutions, each project reflects our expertise and attention to
//             detail. Our portfolio showcases a range of residential and
//             commercial constructions completed with care and efficiency.Explore
//             our projects to experience the professionalism that define Emibau.
//           </p>
//           <Link to="/projects">
//             <button onClick={openToTop}>Our Projects</button>
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Home;
